import Vue from 'vue'
import Vuex from 'vuex'

import * as navigation from '@/store/modules/navigation'
import * as screen from '@/store/modules/screen'
import * as sidebar from '@/store/modules/sidebar'
import * as user from '@/store/modules/user'
import * as deleteItems from '@/store/modules/delete'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    navigation,
    screen,
    sidebar,
    user,
    deleteItems
  },
  plugins: []
})
